import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ShieldBan, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Moderation() {
  const [words, setWords] = useState([]);
  const [newWord, setNewWord] = useState("");

  const load = async () => setWords((await api.get("/banned")).data);
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!newWord.trim()) return;
    await api.post("/banned", { word: newWord.trim() });
    setNewWord(""); load(); toast.success("Banned word added");
  };
  const del = async (w) => { await api.delete(`/banned/${encodeURIComponent(w)}`); load(); toast.success("Removed"); };

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-3xl md:text-4xl font-800 font-heading">Moderation</h1>
        <p className="text-muted-foreground mt-1 text-sm">Words & phrases Sprinkle Pancake Bot will auto-time-out in chat.</p>
      </header>

      <div className="bg-[#0a0a0a] border border-white/10 rounded-lg p-4 flex gap-2 max-w-xl">
        <Input value={newWord} onChange={(e) => setNewWord(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="Add a banned word or phrase" className="bg-secondary border-white/10 focus:ring-primary" data-testid="banned-word-input" />
        <Button onClick={add} className="bg-primary hover:bg-primary/90 rounded-lg" data-testid="add-banned-button"><Plus className="w-4 h-4 mr-1" />Ban</Button>
      </div>

      <div className="bg-[#0a0a0a] border border-white/10 rounded-lg p-5 max-w-xl">
        <div className="flex items-center gap-2 mb-4"><ShieldBan className="w-4 h-4 text-red-400" /><h3 className="font-heading font-700 text-sm">Banned List ({words.length})</h3></div>
        <div className="flex flex-wrap gap-2" data-testid="banned-list">
          {words.map((w) => (
            <span key={w.id || w.word} className="group flex items-center gap-2 px-3 py-1.5 rounded-full bg-red-500/10 border border-red-500/30 text-sm text-red-300" data-testid={`banned-${w.word}`}>
              {w.word}
              <button onClick={() => del(w.word)} className="opacity-60 hover:opacity-100" data-testid={`delete-banned-${w.word}`}><Trash2 className="w-3.5 h-3.5" /></button>
            </span>
          ))}
          {words.length === 0 && <p className="text-sm text-muted-foreground">No banned words yet.</p>}
        </div>
      </div>
    </div>
  );
}
